import React from 'react';
import {
    MobileTimePicker,
    DesktopTimePicker,
    PickerChangeHandlerContext,
    DateTimeValidationError,
} from '@mui/x-date-pickers';
import { InputLabel } from '@mui/material';
import { Moment } from 'moment';

interface Props {
    readonly label?: string;
    readonly value: Moment;
    readonly onChange: (from: Moment | null, context: PickerChangeHandlerContext<DateTimeValidationError>) => void;
    readonly disablePast?: boolean;
    readonly ampm?: boolean;
}

export class TimePicker extends React.Component<Props> {
    render() {
        const { label, value, onChange, disablePast, ampm } = this.props;
        return (
            <>
                {label && label !== '' && (
                    <InputLabel>{label}</InputLabel>
                )}
                <MobileTimePicker sx={{ display: { xs: 'block', sm: 'none' } }} value={value} onChange={onChange} disablePast={disablePast} ampm={ampm} />
                <DesktopTimePicker sx={{ display: { xs: 'none', sm: 'block' } }} value={value} onChange={onChange} disablePast={disablePast} ampm={ampm} />
            </>
        );
    }
}